<template>
  <el-dialog
    :title="category.id ? 'Редактирование категории' : 'Создание категории'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="category"
      :rules="categoryRules"
      @submit.native.prevent="saveCategory"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="category.name"
          ref="categoryToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          maxlength="10000"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6}"
          v-model="category.description"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveCategory"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "category-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      category: {
        id: null,
        name: null,
        description: '',
      },
      categoryRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    async open(category) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.category = Object.assign({}, category);
      this.show = true;
      this.$nextTick(() => this.$refs.categoryToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveCategory() {
      if (this.category.id) {
        this.updateCategory();
      } else {
        this.createCategory();
      }
    },
    createCategory() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.categoryCreate({
          name: this.category.name,
          description: this.category.description,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Категория успешно создана'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('category-saved');
          })
      })
    },
    updateCategory() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.categoryUpdate({
          id: this.category.id,
          name: this.category.name,
          description: this.category.description,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Категория успешно обновлена'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('category-saved');
          })
      })
    }
  }
}
</script>

<style scoped>

</style>